// Centralized schema exports for the entire application
// This follows senior engineering practices for maintainable, consistent validation

// Contact form schemas and types
export * from "./contact";
export { contactSchemas } from "./contact";

// AI feature schemas and types
export * from "./ai";
export { aiSchemas } from "./ai";

// Blog feature schemas and types
export * from "./blog";
export { blogSchemas } from "./blog";

// Re-export contact schemas
export {
  generalFormSchema,
  feedbackFormSchema,
  applicationSchema,
  testimonialSchema,
  supportFormSchema,
} from "./contact";

export {
  chatRequestSchema as ChatRequestSchema,
  homeworkRequestSchema as HomeworkRequestSchema,
  researchRequestSchema as ResearchRequestSchema,
} from "./ai";

export {
  createBlogPostSchema as CreateBlogPostSchema,
  createCommentSchema as CreateCommentSchema,
} from "./blog";

// Schema collections for organized access
export const schemas = {
  contact: {
    general: () => import("./contact").then((m) => m.generalFormSchema),
    feedback: () => import("./contact").then((m) => m.feedbackFormSchema),
    application: () => import("./contact").then((m) => m.applicationSchema),
    testimonial: () => import("./contact").then((m) => m.testimonialSchema),
    support: () => import("./contact").then((m) => m.supportFormSchema),
  },
  ai: {
    chat: () => import("./ai").then((m) => m.chatRequestSchema),
    homework: () => import("./ai").then((m) => m.homeworkRequestSchema),
    research: () => import("./ai").then((m) => m.researchRequestSchema),
  },
  blog: {
    createPost: () => import("./blog").then((m) => m.createBlogPostSchema),
    createComment: () => import("./blog").then((m) => m.createCommentSchema),
    like: () => import("./blog").then((m) => m.likeSchema),
    share: () => import("./blog").then((m) => m.shareSchema),
  },
} as const;
export const customZodResolver = (schema: any) => async (values: any) => { const result = await schema.safeParseAsync(values); if (result.success) { return { values: result.data, errors: {} }; } else { const errors = result.error.issues.reduce((acc: any, issue: any) => { const path = issue.path[0] as string; if (!acc[path]) { acc[path] = { type: issue.code, message: issue.message }; } return acc; }, {}); return { values: {}, errors }; } };
